<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 13V11H5V13H3ZM3 9V7H5V9H3ZM3 5V3H5V5H3ZM7 5V3H9V5H7ZM11 21V19H13V21H11ZM11 5V3H13V5H11ZM15 21V19H17V21H15ZM19 21V19H21V21H19ZM19 17V15H21V17H19ZM19 13V11H21V13H19ZM19 9V5H15V3H21V9H19ZM3 21V15H5V19H9V21H3Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGFrame',
};
</script>

<style scoped>

</style>